/* bundle builder */
try {
  $("body").delegate(".parent_item .quantity-selector", "click", function () {
    document.body.classList.add("refreshing_cart");
    setTimeout(function () {
      document.body.classList.remove("refreshing_cart");
    }, 6000);
  });

  $("body").delegate(
    ".parent_item .line-item__remove-button",
    "click",
    function () {
      document.body.classList.add("refreshing_cart");
      setTimeout(function () {
        document.body.classList.remove("refreshing_cart");
      }, 6000);
    }
  );
} catch (e) {}
$(function () {
  function bundleProductClose() {
    $(".product-bundle-popup-overlay").removeClass("open");
    $(".product-bundle-popup").removeClass("open");
  }
  function stepProducts(step) {
    var originalStep = step;
    if (step) {
      var step = step;
      $(".product-bundle-products-selection").each(function () {
        var firstBlank = $(this).find(
          ".product-bundle-add-product:not(.added):first"
        );
        $(".product-bundle-add-product").removeClass("first-blank");
        $(firstBlank).addClass("first-blank");
        step = $(firstBlank).attr("data-step");
      });
      step = step ? step : originalStep;
      if (originalStep) {
        step = originalStep;
      }
      $(
        ".bundle-popup-products .bundle-popup-products-block-wrapper"
      ).removeClass("open");
      let el = $(
        ".bundle-popup-products-block-wrapper[data-step='" + step + "']"
      );
      $(el).addClass("open");
    }
  }
  function bundleProductOpen(step) {
    $(".product-bundle-popup-overlay").addClass("open");
    $(".product-bundle-popup").addClass("open");
    $(
      ".bundle-popup-products .bundle-popup-products-block-wrapper"
    ).removeClass("open");

    if (step) {
      stepProducts(step);
    } else {
      $(".bundle-popup-products .bundle-popup-products-block-wrapper")
        .eq(0)
        .addClass("open");
    }
  }
  $(".product-bundle-popup-overlay").click(function () {
    bundleProductClose();
  });
  $(".bundle-popup-products-block-btn").click(function (e) {
    document.querySelector("#AddToCart").click();
    setTimeout(function () {
      bundleProductClose();
    }, 1);
  });
  $(".bundle-popup-close").click(function (e) {
    bundleProductClose();
  });
  $(".product-bundle-add-product").click(function (e) {
    bundleProductOpen($(this).attr("data-step"));

    stepProducts($(this).attr("data-step"));

    $(".product-bundle-add-product").removeClass("first-blank");
    var that = this;
    $(".product-bundle-products-selection").each(function () {
      var getClicked = $(this)
        .find(".product-bundle-add-product")
        .eq($(that).index());
      $(getClicked).addClass("first-blank");
    });
  });
  function setActiveProduct(vid, title, img, step) {
    $(".product-bundle-products-selection").each(function () {
      var removeEl = $(this).find(
        `.product-bundle-add-product[data-step="${step}"]`
      );
      $(removeEl).removeClass("added");
      $(removeEl).removeAttr("data-vid");
      $(removeEl).find(".p-img").remove();
      $(removeEl).find(".p-title").remove();
    });

    $(".product-bundle-products-selection").each(function () {
      var firstElement = $(
        `.product-bundle-add-product[data-step="${step}"]:not(.added)`
      );
      firstElement.addClass("added");
      $(firstElement).attr("data-vid", vid);
      const pimg = `<img src="${img}" class="p-img">`;
      const ptitle = `<p class="p-title">${
        title.length > 35 ? title.substring(0, 25) + "..." : title
      }</p>`;
      $(firstElement).find(".product-bundle-add-product-img").append(pimg);
      firstElement.append(ptitle);

      var firstBlank = $(this).find(
        ".product-bundle-add-product:not(.added):first"
      );
      stepProducts($(firstBlank).attr("data-step"));
    });
  }
  function removeActiveProduct(varaintId, index) {
    let foundFirst = false;

    activeProducts = activeProducts.filter((el) => {
      if (!foundFirst && el.vid == varaintId) {
        foundFirst = true;
        return false;
      }
      return true;
    });

    $(".product-bundle-products-selection").each(function () {
      var removeEl = $(this).find(".product-bundle-add-product").eq(index);
      $(removeEl).removeClass("added");
      $(removeEl).removeAttr("data-vid");
      $(removeEl).find(".p-img").remove();
      $(removeEl).find(".p-title").remove();
    });

    updateDOM(activeProducts);
  }
  function updateDOM(activeProducts) {
    let activeProductsLength = activeProducts.length;
    $(".number-of-selected-items").text(activeProductsLength);
    let percent = (activeProductsLength / numberOfSteps) * 100;
    $(".product-bundle-popup .progress-bar-fill").css({
      width: percent + "%",
    });
    var buttons = document.querySelectorAll(".bundle-popup-products-block-btn");
    if (activeProductsLength == numberOfSteps) {
      $(".bundle-popup-products-block-btn").removeAttr("disabled");
      $(".product-bundle-wrapper").addClass("filled");
      $(".product__info #AddToCart").removeAttr("disabled");
      $("#StickyAddToCart").removeAttr("disabled");
      buttons.forEach((button) => {
        const dataText = "Set in den Warenkorb packen";

        button.textContent = dataText;
      });
    } else {
      $(".product-bundle-wrapper").removeClass("filled");
      $(".bundle-popup-products-block-btn").attr("disabled", true);
      // $(".product__info #AddToCart").attr("disabled", true);
      // $("#StickyAddToCart").attr("disabled", true);

      buttons.forEach((button) => {
        const dataText = button.getAttribute("data-text");

        button.textContent = dataText;
      });
    }

    var productPrice =
      parseFloat(
        document
          .querySelector(".price-list [data-ed-price]")
          .getAttribute("data-ed-price")
      ) / 100;
    var total = productPrice;
    var additionalPrices = [];

    // Der initiale Text wird später definiert, basierend darauf, ob Zusatzoptionen vorhanden sind
    var temp = "";

    activeProducts.forEach(function (el) {
      if (el.price > 0) {
        additionalPrices.push(el.price.toFixed(2) + "€"); // Fügt nur den Preis hinzu, wenn er größer als 0 ist
        total += parseFloat(el.price);
      }
    });

    // Zusätzliche Preise in den String einfügen, falls vorhanden
    if (additionalPrices.length > 0) {
      var additionalPricesString = additionalPrices.join(" + ");
      temp = `<strong>Set:</strong> ${productPrice}€ + Auswahl: ${additionalPricesString} = <strong class="final-price">${total.toFixed(
        2
      )}€</strong>`;
    } else {
      // Zeigt nur den Basispreis an, wenn keine Zusatzoptionen über 0€ gewählt wurden
      temp = `<strong>Set:</strong> ${productPrice}€`;
    }

    // Verwendung von .html() um sicherzustellen, dass HTML-Tags korrekt interpretiert werden
    // $(".product-bundle-popup-header-left").html(temp);
  }
  $(".bundle-popup-products-block-product").click(function (e) {
    e.preventDefault();
    var stepAdded = false;

    let step = $(this).attr("data-step");
    // let doubleProduct =
    //   $(this).attr("data-doubleproduct") === "true" ? true : false;

    for (let item of activeProducts) {
      if (item.step == step) {
        stepAdded = true;
      }
    }

    if (!$(this).hasClass("soldout")) {
      let vid = $(this).attr("data-vid");
      let title = $(this).attr("data-title");
      let img = $(this).attr("data-img");
      let index = parseInt($(this)
        .parents(".bundle-popup-products-block-wrapper")
        .attr("data-index"));
      let price = parseFloat(
        $(this).find(".bundle-product-price").text().replace(",", ".")
      );
      let optional = $(this).attr("data-optional") === "1" ? true : false;

      activeProducts = activeProducts.filter(function (item) {
        return item.step !== step;
      });

      if (activeProducts.length != numberOfSteps) {
        activeProducts.push({
          vid,
          title,
          img,
          step,
          price,
          optional,
          index,
        });
        setActiveProduct(vid, title, img, step);
        updateDOM(activeProducts);
      } else {
      }
    }
  });

  $(".bundle-product-cross").click(function (e) {
    e.preventDefault();
    let parent = $(this).parents(".product-bundle-add-product");
    removeActiveProduct($(parent).attr("data-vid"), $(parent).index());
  });
});

/* bundle builder */
